import type { QueueItem } from "../../hooks/useUploadQueue.js";
import { UploadProgressItem } from "./UploadProgressItem.js";
import { UploadOverallProgress } from "./UploadOverallProgress.js";

export function UploadQueue({
  items,
  isUploading,
  onRetry,
  onRemove,
}: {
  items: QueueItem[];
  isUploading: boolean;
  onRetry: (id: string) => void;
  onRemove: (id: string) => void;
}) {
  if (items.length === 0) return null;

  return (
    <div className="stack">
      <UploadOverallProgress items={items} isUploading={isUploading} />
      {items.map((item) => (
        <UploadProgressItem key={item.id} item={item} onRetry={onRetry} onRemove={onRemove} />
      ))}
    </div>
  );
}
